<template>
    <div id="loan-status-dates">
        <div class="vx-row">
            <div class="vx-col w-full">
                <h6 class="bold success">
                    COBRANZA
                </h6>
                <div class="vx-row">
                    <div class="vx-col w-full">
                        <vs-list>
                            <vs-list-item title="Estado del activo">{{ explicitAssetStatus(source.finance.asset_status) }}</vs-list-item>
                            <vs-list-item title="Estado del pago">{{ explicitCreditStatus(source.finance.credit_status) }}</vs-list-item>
                            <vs-list-item title="Estado de la cobranza">{{ translateFinanceCollectionStatus(source.finance.collection_status) }} 
                                <template v-if="source.finance.collection_substatus != null">
                                    | {{ translateFinanceCollectionSubStatus(source.finance.collection_substatus) }}
                                </template>
                            </vs-list-item>
                        </vs-list>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import creditStatusesHelper from '@mixins/creditStatusesHelper';
import dateHelper from '@mixins/dateHelper';
import projectStatusesHelper from '@mixins/projectStatusesHelper';

    export default {
        name: "CashoinDetail",
        mixins: [dateHelper, creditStatusesHelper, projectStatusesHelper],
        data: () => ({

        }),
        props: {
            source: Object
        }
    }
</script>

<style>
#loan-status-dates .vx-card__body {
    padding: .5rem !important;
}
</style>